module.exports = __webpack_public_path__ + "assets/img/reminder-collate-2.2244abbd.png";